import { connect } from 'react-redux';
import { getSearchResultsSelector, getAdvancedSearchFilterBySelector } from 'redux-core/header/selectors';

const mapStateToProps = (state) => ({
  searchResults: getSearchResultsSelector(state),
  filterBy: getAdvancedSearchFilterBySelector(state),
});

export default connect(mapStateToProps);
